import { jobsApi } from "@facade/services";
import { useMutation } from "@tanstack/react-query";

export function useDownloadJobResultMutation() {
  return useMutation({
    mutationFn: (jobId: string) => jobsApi.getDownload(jobId),
    onSuccess: (result) => {
      const anchor = document.createElement("a");
      anchor.href = result.url;
      anchor.download = result.fileName;
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
    },
  });
}
